import {useState} from 'react'
import logger from '@/lib/logger'
import {onInputFocus} from '@/lib/inputFocus'
import composesStyles from '@/styles/_settings/composes.module.css'
import labelStyles from '@/styles/atoms/Label/styles.module.css'
import inputStyles from '@/styles/atoms/Input/styles.module.css'
import SharedButton from '@/components/shared/Button'
import Button from '@/components/form/Button'
import buttonStyles from '@/styles/atoms/Button/styles.module.css'
import CurrencyInput from '@/components/form/CurrencyInput'
import {STEPINFOCONSTS} from '../../lib'
import {
  description,
  roomsLabel,
  suitesLabel,
  bathroomsLabel,
  areaLabel,
  maintenanceFeeLabel,
  garageSpotsLabel,
  elementsValues
} from '../../lib'

const Info = ({state, onChange, loggerAction}) => {
  const [show, setShow] = useState(false)
  const {MIN_AREA_VALUE, MAX_AREA_VALUE} = STEPINFOCONSTS

  const selectButtons = (type, state) => {
    return elementsValues[type].map((value, index) => {
      return (
        <SharedButton
          small
          key={index}
          selected={state === value}
          value={value}
        >
          {value}
        </SharedButton>
      )
    })
  }

  return (
    <div
      className={`${composesStyles.animation_enterfrombottom} ${composesStyles.paddingx} ${composesStyles.fullmaxwidth}`}
    >
      {state && (
        <>
          <label
            className={`${labelStyles.ecLabel} ${labelStyles.ecLabel_formItem}`}
          >
            <span className={labelStyles.ecLabel__value}>{description}</span>
          </label>
          <label
            className={`${labelStyles.ecLabel} ${labelStyles.ecLabel_formItem}`}
          >
            <span className={labelStyles.ecLabel__value}>{roomsLabel}</span>
            <div className={buttonStyles.ecButtonWrapper__ui}>
              <Button.Group
                initialValue={0}
                onChange={(e) => {
                  onChange({...state, rooms: e})
                  logger.action(loggerAction.rooms)
                }}
              >
                {selectButtons('rooms', state.rooms)}
              </Button.Group>
            </div>
          </label>
          {state.rooms && (
            <div className={composesStyles.animation_enterfrombottom}>
              <label
                className={`${labelStyles.ecLabel} ${labelStyles.ecLabel_formItem}`}
              >
                <span className={labelStyles.ecLabel__value}>
                  {suitesLabel}
                </span>
                <div className={buttonStyles.ecButtonWrapper__ui}>
                  <Button.Group
                    initialValue={0}
                    onChange={(e) => {
                      onChange({...state, suites: e})
                      logger.action(loggerAction.suites)
                    }}
                  >
                    {selectButtons('suitesBathrooms', state.suites)}
                  </Button.Group>
                </div>
              </label>
            </div>
          )}
          {state.suites >= 0 && (
            <div className={composesStyles.animation_enterfrombottom}>
              <label
                className={`${labelStyles.ecLabel} ${labelStyles.ecLabel_formItem}`}
              >
                <span className={labelStyles.ecLabel__value}>
                  {bathroomsLabel}
                </span>
                <div className={buttonStyles.ecButtonWrapper__ui}>
                  <Button.Group
                    initialValue={0}
                    onChange={(e) => {
                      onChange({...state, bathrooms: e})
                      logger.action(loggerAction.bath)
                    }}
                  >
                    {selectButtons('suitesBathrooms', state.bathrooms)}
                  </Button.Group>
                </div>
              </label>
            </div>
          )}
          {state.bathrooms >= 0 && (
            <div className={composesStyles.animation_enterfrombottom}>
              <label
                className={`${labelStyles.ecLabel} ${labelStyles.ecLabel_formItem}`}
              >
                <span className={labelStyles.ecLabel__value}>{areaLabel}</span>
                <input
                  className={inputStyles.ecInput}
                  type="number"
                  name="area"
                  tabIndex="0"
                  placeholder="Ex: 20m2"
                  value={state.area}
                  onChange={({target}) => {
                    if (!state.area) {
                      logger.action(loggerAction.area)
                    }
                    onChange({...state, area: parseInt(target.value)})
                  }}
                  onFocus={
                    ((e) => onInputFocus(e.target.offsetTop),
                    () => setShow(true))
                  }
                  onBlur={() => setShow(false)}
                />
                {show &&
                  (state.area < MIN_AREA_VALUE ||
                    state.area > MAX_AREA_VALUE) && (
                    <span className={labelStyles.ecLabel__warning}>
                      {`Coloque um valor entre ${MIN_AREA_VALUE} e ${MAX_AREA_VALUE} m2`}
                    </span>
                  )}
              </label>
            </div>
          )}
          {state.area >= MIN_AREA_VALUE && (
            <>
              <div className={composesStyles.animation_enterfrombottom}>
                <label
                  className={`${labelStyles.ecLabel} ${labelStyles.ecLabel_formItem}`}
                >
                  <span className={labelStyles.ecLabel__value}>
                    {maintenanceFeeLabel}
                  </span>
                  <CurrencyInput
                    name="condo"
                    tabIndex="0"
                    value={state.maintenanceFee || undefined}
                    onChange={(e) => {
                      if (!state.maintenanceFee) {
                        logger.action(loggerAction.condo)
                      }
                      onChange({...state, maintenanceFee: e})
                    }}
                    placeholder="Ex: R$ 500"
                    onFocus={(e) => onInputFocus(e.target.offsetTop)}
                  />
                </label>
              </div>
              <label
                className={`${labelStyles.ecLabel} ${labelStyles.ecLabel_formItem}`}
              >
                <span className={labelStyles.ecLabel__value}>
                  {garageSpotsLabel}
                </span>
                <div className={buttonStyles.ecButtonWrapper__ui}>
                  <Button.Group
                    initialValue={0}
                    onChange={(e) => {
                      onChange({...state, garageSpots: e})
                      logger.action(loggerAction.garageSpots)
                    }}
                  >
                    {selectButtons('garageSpots', state.garageSpots)}
                  </Button.Group>
                </div>
              </label>
            </>
          )}
        </>
      )}
    </div>
  )
}

export default Info
